// extracted by mini-css-extract-plugin
export default {"productcard":"xG","productimage":"yG","username":"zG","multiBagName":"AG","productinfo":"BG","productinfoinner":"CG","productname":"EG","productsubheader":"FG","productdescription":"GG","productnumbers":"HG","productnumberstitle":"IG","productnumbersitem":"JG","number":"KG","numbertext":"LG","tabs":"MG","benefitsblock":"NG","benefit":"OG","benefitname":"PG","benefitdescription":"QG","ingredientsblock":"RG","tipsblock":"SG","mobileonly":"TG"};
    if(module.hot) {
      // 1713996747663
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  